const USER_URL = process.env.API_URL + '/v2/xugarhero/user/';

const getUserAddress = (context, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(USER_URL + userId + '/address').then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default{
  getUserAddress
};



// WEBPACK FOOTER //
// ./src/brand/health/api/address/index.js